import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 11V4H18V20H16V13H8V20H6V4H8V11H16Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Heading"
);
